@switch (state) {
  @case (ViewLoadState.FETCHING) {
    @if (fetchingTemplate) {
      <ng-container *ngTemplateOutlet="fetchingTemplate"></ng-container>
    } @else {
      <ng-container i18n="@@Loading...">Loading...</ng-container>
    }
  }
  @case (ViewLoadState.FETCHED) {
    <ng-container *ngTemplateOutlet="fetchedTemplate"></ng-container>
  }
  @case (ViewLoadState.ERROR) {
    @if (errorTemplate) {
      <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
    } @else {
      <span
        class="error"
        i18n="@@Error_during_fetching"
        >Error during fetching</span
      >
    }
  }
  @case (ViewLoadState.NO_DATA) {
    @if (unavailableTemplate) {
      <ng-container *ngTemplateOutlet="unavailableTemplate"></ng-container>
    } @else {
      <span
        class="unavailable"
        i18n="@@Unavailable"
        >Unavailable</span
      >
    }
  }
  @default {
    <ng-container *ngTemplateOutlet="defaultUnavailableTemplate"></ng-container>
  }
}

<ng-template #defaultUnavailableTemplate>
  <span
    class="unavailable"
    i18n="@@Unavailable"
    >Unavailable</span
  >
</ng-template>
